import { WorkspaceConfig_FHIRSandbox, WorkspaceKey_FHIRSandbox } from './sandbox/Sandbox_FHIR/workspace.js';
export const workspaceKey_AdvisorSandboxEpic = 'workspace-key--advisor-sandbox--epic';
export const WorkspaceConfig_AdvisorSandboxEpic = {
    name: 'Healthcare Space',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'LeftPanel', key: 'templates', visible: true, factor: 1 / 5, min: 150,
                data: {
                    filter: ''
                }
            },
            {
                name: 'centerPanel', key: 'composer', visible: true, factor: 2 / 5, min: 300,
                data: {
                    filter: '',
                    categoryFilter: undefined,
                }
            },
            {
                name: 'RightPanel', key: 'history', visible: true, factor: 2 / 5, min: 300,
                data: {
                    filter: '',
                }
            },
        ]
    }
};
export const defaultWorkspaceConfigs = {
    [workspaceKey_AdvisorSandboxEpic]: WorkspaceConfig_AdvisorSandboxEpic,
    [WorkspaceKey_FHIRSandbox]: WorkspaceConfig_FHIRSandbox,
};
//# sourceMappingURL=workspace-configs.js.map